import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import localforage from "localforage";
import "./CommoditiesDash.css";
import { useMarketToggle } from "../../context/MarketContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useNews } from "../../context/NewsContext";
import { FaSpinner } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { FaFireAlt } from "react-icons/fa";

import { useRecommendation } from "../../context/RecommendationContext";
const CACHE_EXPIRY = 60 * 60 * 1000;

const CommoditiesDash = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [commData, setCommData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { setRecommendation, setCommoditiesData } = useRecommendation();
  const [lastUpdated, setLastUpdated] = useState("");
  const [selectedStock, setSelectedStock] = useState(5);

  const navigate = useNavigate();
  const { market, toggleMarket } = useMarketToggle();
  // const [news, setNews] = useState();
  // const [globalNews, setGlobalNews] = useState();
  const { news, globalNews, fetchNews } = useNews();

  console.log("News", news);
  console.log("Globalnews", globalNews); // ✅ destructure values
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  const fetchCommodities = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/api/commodities`);
      console.log("Fetched Commodities Data", response.data);

      setCommData(response.data);
      const timestamp = formatTimestamp();
      const resData = response.data;

      localStorage.setItem(
        "commoditiesCache",
        JSON.stringify({ resData, timestamp }),
      );
    } catch (err) {
      console.error("Error fetching commodities:", err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const cachedCommodities = localStorage.getItem("commoditiesCache");

  //   if (cachedCommodities) {
  //     console.log("✅ Loaded cached commodities data");
  //     setCommData(JSON.parse(cachedCommodities));

  //   } else {
  //     console.log("No cache found, fetching commodities...");
  //     fetchCommodities();
  //   }

  //   // const loadCachedNews = async () => {
  //   //   try {
  //   //     // ✅ Await both calls
  //   //     const cachedNews = await localforage.getItem("newsCache");
  //   //     const cachedGlobalNews = await localforage.getItem("globalNewsCache");

  //   //     if (cachedNews && cachedGlobalNews) {
  //   //       console.log("Loaded cached news data");
  //   //       setNews(cachedNews);
  //   //       setGlobalNews(cachedGlobalNews);
  //   //     } else {
  //   //       console.log("No cache found, fetching fresh news...");
  //   //       fetchNews();
  //   //     }
  //   //   } catch (err) {
  //   //     console.error(" Failed to load cached news:", err);
  //   //     fetchNews(); // fallback
  //   //   }
  //   // };

  //   // loadCachedNews();
  // }, []);
  useEffect(() => {
    const cached = localStorage.getItem("commoditiesCache");

    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        console.log("✅ Loaded cached commodities");

        setCommData(parsed.resData); // ✅ FIXED
        setLastUpdated(parsed.timestamp);
      } catch (err) {
        console.error("❌ Cache parse error:", err);
        fetchCommodities(); // fallback
      }
    } else {
      console.log("🆕 No cache found, fetching...");
      fetchCommodities();
    }
  }, []);

  // const fetchNews = async () => {
  // //   try {
  // //     const [response1, response2] = await Promise.all([
  // //       axios.get(`${BASE_URL}/api/news`),
  // //       axios.get(`${BASE_URL}/api/globalnews`),
  // //     ]);

  // //     setNews(response1.data);
  // //     setGlobalNews(response2.data.data.feed);
  // //   } catch (err) {
  // //     console.error("Error fetching news:", err.message);
  // //   }
  // // };

  // // ✅ Manual refresh handler
  // const fetchNews = async () => {
  //   try {
  //     const [response1, response2] = await Promise.all([
  //       axios.get(`${BASE_URL}/api/news`),
  //       axios.get(`${BASE_URL}/api/globalnews`),
  //     ]);

  //     console.log("News fetched successfully");

  //     const localNews = response1.data;
  //     const globalNews = response2.data.data.feed;

  //     // ✅ Update State
  //     setNews(localNews);
  //     setGlobalNews(globalNews);

  //     // ✅ Save both to localStorage
  //     localStorage.setItem("newsCache", JSON.stringify(localNews));
  //     localStorage.setItem("globalNewsCache", JSON.stringify(globalNews));
  //   } catch (err) {
  //     console.error(" Error fetching news:", err.message);
  //   }
  // };
  //New COde
  // const fetchNews = async () => {
  //   try {
  //     setLoading(true);
  //     console.log("🌐 Fetching news...");

  //     // Fetch local and global news simultaneously
  //     const [localRes, globalRes] = await Promise.all([
  //       axios.get(`${BASE_URL}/api/news`),
  //       axios.get(`${BASE_URL}/api/globalnews`),
  //     ]);

  //     const localNews = localRes.data || [];
  //     const globalFeed =
  //       globalRes?.data?.data?.feed && Array.isArray(globalRes.data.data.feed)
  //         ? globalRes.data.data.feed
  //         : [];

  //     // ✅ Save in state
  //     setNews(localNews);
  //     setGlobalNews(globalFeed);

  //     // ✅ Save to localforage (no JSON.stringify)
  //     await localforage.setItem("newsCache", localNews);
  //     await localforage.setItem("globalNewsCache", globalFeed);

  //     console.log("News cached successfully");
  //   } catch (err) {
  //     console.error(" Error fetching news:", err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   const loadCachedNews = async () => {
  //     setLoading(true);

  //     const cachedLocalNews = await localforage.getItem("newsCache");
  //     const cachedGlobalNews = await localforage.getItem("globalNewsCache");

  //     if (cachedLocalNews) setNews(cachedLocalNews);
  //     if (cachedGlobalNews) setGlobalNews(cachedGlobalNews);

  //     // Fetch fresh data after showing cache
  //     fetchNews();
  //   };

  //   loadCachedNews();
  // }, []);

  // useEffect(() => {
  //   loadCachedData();
  // }, []);

  // ✅ Centralized function to load cached data first
  // const loadCachedData = () => {
  //   // --- Commodities Cache ---
  //   const cachedCommodities = localStorage.getItem("commoditiesCache");
  //   if (cachedCommodities) {
  //     try {
  //       console.log("Loaded cached commodities data");
  //       setCommData(JSON.parse(cachedCommodities));
  //     } catch (err) {
  //       console.error("Failed to parse commodities cache:", err);
  //       fetchCommodities(); // fallback
  //     }
  //   } else {
  //     console.log("No cache found, fetching commodities...");
  //     fetchCommodities();
  //   }

  //   // --- News Cache ---
  //   const cachedNews = localforage.getItem("newsCache");
  //   const cachedGlobalNews = localforage.getItem("globalNewsCache");

  //   if (cachedNews && cachedGlobalNews) {
  //     try {
  //       console.log("Loaded cached news data");
  //       setNews(JSON.parse(cachedNews));
  //       setGlobalNews(JSON.parse(cachedGlobalNews));
  //     } catch (err) {
  //       console.error("Failed to parse news cache:", err);
  //       fetchNews(); // fallback
  //     }
  //   } else {
  //     console.log("🆕 No cache found, fetching news...");
  //     fetchNews();
  //   }
  // };

  // ✅ Fetch Commodities (with cache update)
  // const fetchCommodities = async () => {
  //   try {
  //     setLoading(true);
  //     console.log("Fetching fresh commodities data...");

  //     const response = await axios.get(`${BASE_URL}/api/commodities`);
  //     const data = response.data;

  //     if (!data || !Array.isArray(data)) {
  //       throw new Error("Invalid commodities data received");
  //     }

  //     setCommData(data);

  //     // ✅ Update localStorage cache
  //     localStorage.setItem("commoditiesCache", JSON.stringify(data));
  //     console.log("Commodities cached successfully");
  //   } catch (err) {
  //     console.error("Error fetching commodities:", err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Fetch News (with cache update)
  // const fetchNews = async () => {
  //   try {
  //     console.log("🌐 Fetching latest news data...");
  //     const [response1, response2] = await Promise.all([
  //       axios.get(`${BASE_URL}/api/news`),
  //       axios.get(`${BASE_URL}/api/globalnews`),
  //     ]);

  //     const localNews = response1.data || [];
  //     const globalNews =
  //       response2?.data?.data?.feed && Array.isArray(response2.data.data.feed)
  //         ? response2.data.data.feed
  //         : [];

  //     setNews(localNews);
  //     setGlobalNews(globalNews);

  //     await localforage.setItem("newsCache", JSON.stringify(localNews));
  //     await localforage.setItem("globalNewsCache", JSON.stringify(globalNews));

  //     console.log("💾 News cached successfully");
  //   } catch (err) {
  //     console.error("❌ Error fetching news:", err.message);
  //   }
  // };
  // const fetchNews = async () => {
  //   try {
  //     console.log("🌐 Fetching latest news data...");

  //     // 1️⃣ Fetch local news first
  //     const localResponse = await axios.get(`${BASE_URL}/api/news`);
  //     const localNews = localResponse.data || [];
  //     setNews(localNews);
  //     await localforage.setItem("newsCache", localNews);
  //     console.log("💾 Local news cached successfully");

  //     // 2️⃣ Fetch global news (non-blocking)
  //     axios
  //       .get(`${BASE_URL}/api/globalnews`)
  //       .then(async (response) => {
  //         const feed = response?.data?.data?.feed;
  //         const globalNews = Array.isArray(feed) ? feed : [];
  //         setGlobalNews(globalNews);
  //         await localforage.setItem("globalNewsCache", globalNews);
  //         console.log("💾 Global news cached successfully");
  //       })
  //       .catch((err) =>
  //         console.error("❌ Error fetching global news:", err.message)
  //       );
  //   } catch (err) {
  //     console.error("❌ Error fetching local news:", err.message);
  //   }
  // };

  // useEffect(() => {
  //   const cached = localStorage.getItem("commoditiesCache");

  //   if (cached) {
  //     const parsed = JSON.parse(cached);
  //     console.log("Loaded cached commodities");

  //     setCommData(parsed.resData);
  //     setLastUpdated(parsed.timestamp || formatTimestamp());
  //   } else {
  //     console.log("No cache found, fetching...");
  //     fetchCommodities();
  //   }
  // }, []);
  const handleRefresh = () => {
    console.log("Manual refresh triggered");
    fetchCommodities();
    fetchNews();
  };

  console.log("Commodities", commData);
  console.log("News", news);
  console.log("Global News", globalNews);
  // useEffect(() => {
  //   const fetchCommodities = async () => {
  //     try {
  //       setLoading(true);
  //       // const response = await axios.get(
  //       //   "http://localhost:8000/api/commodities"
  //       // );
  //       const response = await axios.get(`${BASE_URL}/api/commodities`);
  //       console.log("News data", response.data);
  //       setCommData(response.data);
  //       // setStock(response.data);
  //     } catch (err) {
  //       console.log("Error is :-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchCommodities();
  // }, []);
  console.log("Commodities", commData);
  const formatVolume = (volume) => {
    return typeof volume === "string"
      ? Number(volume).toLocaleString()
      : volume.toLocaleString();
  };
  const handleClickCommodities = (item) => {
    setRecommendation(item);
    navigate("/commodities");
  };
  const isIndia = market === "india";
  const newsToRender = isIndia ? news?.slice(0, 3) : globalNews?.slice(0, 3);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    setLastUpdated(formatTimestamp);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const newsToShow = isMobile ? news?.slice(0, 4) : newsToRender;
  const dropDown1 = [
    { id: 1, name: "Top 5 stocks", value: 5 },
    { id: 2, name: "Top 10 stocks", value: 10 },
    // { id: 3, name: "Top 15 stocks", value: 15 },
    // { id: 4, name: "Top 20 stocks", value: 20 },
  ];

  const options = dropDown1;
  console.log(newsToShow);
  const commGainers = [...commData]
    .sort((a, b) => b.per_change - a.per_change)
    .slice(0, selectedStock);
  console.log("commgainers", commGainers);
  const commLosers = [...commData]
    .sort((a, b) => a.per_change - b.per_change)
    .slice(0, selectedStock);
  const commActive = [...commData]
    .sort((a, b) => b.total_quantity_traded - a.total_quantity_traded)
    .slice(0, selectedStock);

  return (
    <>
      <div className="back-btn">
        <button className="rec-btn" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
      <div className="content">
        {/* <div style={{ textAlign: "right", margin: "10px" }}>
          <button
            onClick={handleRefresh}
            className="rec-btn"
            disabled={loading}
            style={{
              width: "110px",
              padding: "8px 14px",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              width: "150px",
            }}
          >
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div> */}
        <div className="last-updated">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>
        <div className="main">
          <div
            className="card "
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {" "}
            {loading ? (
              <p
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  color: "white",
                }}
              >
                Fetching data...
              </p>
            ) : commData && commData.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexDirection: "column",
                }}
              >
                <div
                  className="dropdown"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "3rem",
                  }}
                >
                  <select
                    onChange={(e) => setSelectedStock(Number(e.target.value))}
                  >
                    {options.map((item) => (
                      <option value={item.value} key={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div>
                  <h2
                    style={{
                      fontSize: "1.5rem",
                      textAlign: "center",
                      fontWeight: "600",
                      color: "white",
                    }}
                  >
                    Commodities Top 3 Gainers
                  </h2>
                  <div className="stock-table-container">
                    <table className="stock-table stacked-mobile">
                      <thead>
                        <tr>
                          <th>Product</th>

                       
                          <th>Price</th>

                         
                          <th>Close</th>
                          <th>% Change</th>
                         
                          <th>Volume</th>
                          <th>Recommendation</th>


                        </tr>
                      </thead>
                      <tbody>
                        {[...commData]
                          .sort((a, b) => b.per_change - a.per_change)
                          .slice(0, 3)
                          .map((item) => (
                            <tr
                              key={item.id}
                              className="stock-row"
                              onClick={() => handleClickCommodities(item)}
                            >
                              <td className="mobile-name">{item.product}</td>

                             
                              <td className="mobile-pair" data-label="Price">
                                ₹{item.last_traded_price}
                              </td>
                             
                              <td className="mobile-pair" data-label="Close">
                                {item.close_price}
                              </td>
                              <td
                                style={{
                                  color:
                                    item.per_change >= 0
                                      ? "#2fd18a"
                                      : "#f87171",
                                  fontWeight: "bold",
                                }}
                                className="mobile-pair"
                                data-label="%Change"
                              >
                                {item.per_change}%
                              </td>
                             

                              <td className="mobile-pair" data-label="Volume">
                                {item.total_quantity_traded}
                              </td>
                              <td className="mobile-button">
                                <button className="rec-btn">BUY or SELL</button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div> */}

                <div className="market-cards">
                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">Top Gainers</h2>
                      <IoMdTrendingUp style={{ color: "#249966" }} />
                    </div>

                    {commGainers?.map((stock) => (
                      <div className="card-row" key={stock?.id}>
                        <div className="left">
                          <p className="name">{stock?.product}</p>
                          <p className="price">₹{stock?.last_traded_price}</p>
                        </div>

                        <div className="right">
                          <p className="change green">+ {stock.per_change}%</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* === TOP LOSERS CARD === */}
                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">Top Losers</h2>
                      <IoMdTrendingDown style={{ color: "#f87171" }} />
                    </div>

                    {commLosers?.map((stock) => (
                      <div className="card-row" key={stock?.id}>
                        <div className="left">
                          <p className="name">{stock?.product}</p>
                          <p className="price">₹{stock?.last_traded_price}</p>
                        </div>

                        <div className="right">
                          <p className="change red">{stock?.per_change}%</p>
                          {/* <button
                                        className="sell-btn"
                                        onClick={() =>
                                          isIndia
                                            ? navigate(`/stock/${stock.ticker_id}`)
                                            : navigate(`/globalstock/${stock.ticker}`)
                                        }
                                      >
                                        Sell
                                      </button> */}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* === MOST ACTIVE CARD === */}
                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">Most Active</h2>
                      <FaFireAlt style={{ color: "#3b82f6" }} />
                    </div>

                    {commActive?.map((stock) => (
                      <div className="card-row" key={stock?.id}>
                        <div className="left">
                          <p className="name">{stock?.product}</p>
                          <p className="price">₹{stock?.last_traded_price}</p>
                        </div>

                        <div className="right">
                          <p
                            className="change"
                            style={{
                              color:
                                stock?.per_change > 0 ? "#249966" : "#f87171",
                              fontWeight: "bold",
                            }}
                          >
                            {/* {stock?.per_change}% */}
                            {stock?.per_change > 0
                              ? `+${stock?.per_change}`
                              : stock?.per_change}
                            %
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h2
                    style={{
                      fontSize: "1.2rem",
                      textAlign: "center",
                      fontWeight: "600",
                      color: "white",
                    }}
                  >
                    Commodities Top 3 Losers
                  </h2>
                  <div className="stock-table-container">
                    <table className="stock-table stacked-mobile">
                      <thead>
                        <tr>
                          <th>Product</th>

                          <th>Price</th>

                          <th>Close</th>
                          <th>% Change</th>

                          <th>Volume</th>
                          <th>Recommendation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...commData]
                          .sort((a, b) => a.per_change - b.per_change)
                          .slice(0, 3)
                          .map((item) => (
                            <tr
                              key={item.id}
                              className="stock-row"
                              onClick={() => handleClickCommodities(item)}
                            >
                              <td className="mobile-name">{item.product}</td>

                              <td className="mobile-pair" data-label="Price">
                                ₹{item.last_traded_price}
                              </td>

                              <td className="mobile-pair" data-label="Close">
                                {item.close_price}
                              </td>
                              <td
                                style={{
                                  color:
                                    item.per_change >= 0
                                      ? "#2fd18a"
                                      : "#f87171",
                                  fontWeight: "bold",
                                }}
                                className="mobile-pair"
                                data-label="%Change"
                              >
                                {item.per_change}%
                              </td>

                              <td className="mobile-pair" data-label="Volume">
                                {formatVolume(item.total_quantity_traded)}
                              </td>
                              <td className="mobile-button">
                                <button className="rec-btn">BUY or SELL</button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h2
                    style={{
                      fontSize: "1.2rem",
                      textAlign: "center",
                      fontWeight: "600",
                      color: "white",
                    }}
                  >
                    Commodities Top 3 Most Active (By Volume)
                  </h2>
                  <div className="stock-table-container">
                    <table className="stock-table stacked-mobile">
                      <thead>
                        <tr>
                          <th>Product</th>

                          <th>Price</th>

                          <th>Close</th>
                          <th>% Change</th>

                          <th>Volume</th>
                          <th>Recommendation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...commData]
                          .sort(
                            (a, b) =>
                              b.total_quantity_traded - a.total_quantity_traded,
                          )
                          .slice(0, 3)
                          .map((item) => (
                            <tr
                              key={item.id}
                              className="stock-row"
                              onClick={() => handleClickCommodities(item)}
                            >
                              <td className="mobile-name">{item.product}</td>

                              <td className="mobile-pair" data-label="Price">
                                ₹{item.last_traded_price}
                              </td>

                              <td className="mobile-pair" data-label="Close">
                                {item.close_price}
                              </td>
                              <td
                                style={{
                                  color:
                                    item.per_change >= 0
                                      ? "#249966"
                                      : "#f87171",
                                  fontWeight: "bold",
                                }}
                                className="mobile-pair"
                                data-label="%Change"
                              >
                                {item.per_change}%
                              </td>

                              <td className="mobile-pair" data-label="Volume">
                                {item.total_quantity_traded}
                              </td>
                              <td className="mobile-button">
                                <button className="rec-btn">BUY or SELL</button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="commodities-more-btn">
                  <button
                    className="rec-btn"
                    onClick={() => {
                      navigate("/commoditiesdetail");
                      setCommoditiesData(commData);
                    }}
                  >
                    View More
                  </button>
                </div>
              </div>
            ) : (
              <p>No data available</p>
            )}
          </div>
          <>
            {/* <h1
              style={{
                fontSize: "1.2rem",
                textAlign: "center",
                fontWeight: "600",
                color: "white",
                padding: "10px",
              }}
            >
              Market News
            </h1>
            <div className="news-card-grid card">
              {(isMobile
                ? newsToRender?.slice(0, 4)
                : newsToRender.slice(0, 3)
              )?.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="news-card"
                >
                  <img
                    src={isIndia ? item.image_url : item.banner_image}
                    alt={item.title}
                    className="news-image"
                  />
                  <div className="news-content">
                    <h3 className="news-title">{item.title}</h3>
                    {isIndia ? (
                      <p className="news-time">
                        {new Date(item.pub_date).toLocaleString("en-IN", {
                          dateStyle: "medium",
                          timeStyle: "short",
                        })}
                      </p>
                    ) : (
                      <p className="news-time">Source - {item.source}</p>
                    )}
                  </div>
                </a>
              ))}
            </div>
            <div className="news-btn">
              <button
                className="rec-btn"
                onClick={() => {
                  navigate("/news");
                }}
              >
                View More
              </button>
            </div> */}
            <div className="card card-grid">
              {!loading && (
                <h1
                  style={{
                    fontSize: "1rem",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "white",
                    padding: "10px",
                  }}
                >
                  Market News
                </h1>
              )}
              {loading ? (
                <p
                  style={{
                    fontSize: "1rem",
                    fontWeight: "700",
                    color: "white",
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  Fetching data..{" "}
                  <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
                    <FaSpinner />
                  </span>
                </p>
              ) : newsToRender ? (
                <>
                  <div className="news-card-grid">
                    {newsToShow?.map((item, index) => (
                      <a
                        key={index}
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="news-card"
                      >
                        <img
                          src={isIndia ? item.image_url : item.banner_image}
                          alt={item.title}
                          className="news-image"
                        />
                        <div className="news-content">
                          <h3 className="news-title">{item.title}</h3>
                          {isIndia ? (
                            <p className="news-time">
                              {new Date(item.pub_date).toLocaleString("en-IN", {
                                dateStyle: "medium",
                                timeStyle: "short",
                              })}
                              <p className="news-time">
                                Source - {item.source}
                              </p>
                            </p>
                          ) : (
                            <p className="news-time">Source - {item.source}</p>
                          )}
                        </div>
                      </a>
                    ))}
                    {/* <div className="news-btn">
                              <button
                                className="rec-btn"
                                onClick={() => {
                                  navigate("/news");
                                }}
                              >
                                View More
                              </button>
                            </div> */}
                  </div>
                  <div className="news-btn">
                    <button
                      className="rec-btn"
                      onClick={() => {
                        navigate("/news");
                      }}
                    >
                      View More
                    </button>
                  </div>
                </>
              ) : (
                <p>No Data Available</p>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default CommoditiesDash;
